import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { mockCaseStudies } from '../mock';

const CaseStudies = () => {
  return (
    <div className="dark-page">
      <section className="page-hero">
        <div className="hero-image-wrapper">
          <img 
            src="https://images.unsplash.com/photo-1559136555-9303baea8ebd" 
            alt="Professionals collaborating in modern office"
            className="hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <h1 className="display-large">Case Studies</h1>
        <p className="body-large page-subtitle">
          Real-world success stories from our clients across various industries
        </p>
      </section>

      <section className="case-studies-section">
        {mockCaseStudies.map((study, index) => (
          <div key={study.id} className="case-study-card">
            <div className="case-study-header">
              <div>
                <h2 className="display-medium">{study.title}</h2>
                <p className="body-medium case-meta">
                  <span className="case-client">{study.client}</span>
                  <span className="case-divider">•</span>
                  <span className="case-industry">{study.industry}</span>
                </p>
              </div>
            </div>

            <div className="case-study-content">
              <div className="case-section">
                <h3 className="heading-3">Challenge</h3>
                <p className="body-medium">{study.challenge}</p>
              </div>

              <div className="case-section">
                <h3 className="heading-3">Solution</h3>
                <p className="body-medium">{study.solution}</p>
              </div>

              <div className="case-section">
                <h3 className="heading-3">Results</h3>
                <div className="results-grid">
                  {study.results.map((result, idx) => (
                    <div key={idx} className="result-item">
                      <TrendingUp size={20} className="result-icon" />
                      <span className="body-medium">{result}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className="cta-section">
        <h2 className="display-medium">Ready to Write Your Success Story?</h2>
        <p className="body-large cta-subtitle">
          Let's discuss how we can help you achieve similar results.
        </p>
        <Link to="/contact" className="btn-primary btn-large">
          Start Your Project
          <ArrowRight size={24} />
        </Link>
      </section>
    </div>
  );
};

export default CaseStudies;